import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';

export interface Props {
  className?: string;
  score: number;
}

class VeraScoreChangeText extends React.Component<Props, any> {
  public static defaultProps: Props = {
    score: 0,
  };

  public render() {
    const { className, score } = this.props;
    if (score === 0) {
      return null;
    }

    let directionClass = 'positive';
    let directionElement = <span>&uarr;</span>;
    if (score < 0) {
      directionClass = 'negative';
      directionElement = <span>&darr;</span>;
    }

    return (
      <div className={`${className} ${directionClass}`}>
        {directionElement}
        <span>{Math.abs(score)}</span>
      </div>
    );
  }
}

export default styled(VeraScoreChangeText)`
  display: inline-block;
  line-height: 24px;
  font-size: 1.15em;

  &.positive {
    color: ${colors.success};
  }
  &.negative {
    color: ${colors.alert};
  }
`;
